import { useEffect, useState } from "react"
import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import {useNavigate} from 'react-router-dom'
import { Modal } from "flowbite-react";
import {CloseModalIcon, InfoIcon} from './SVGIcons'
import {roomDesignActions} from '../reducers/roomDesign'
import RoomTypeImage from '../../assets/images/carousel-1.svg'
import pho_living from '../../assets/images/pho_living.png'
import pho_dining from '../../assets/images/pho_dining.png'
import pho_bedroom from '../../assets/images/pho_bedroom.png'
import pho_oneroom from '../../assets/images/pho_oneroom.png'
import {selectBeforeImageData} from '../selectors'
import OneRoomNoticePopup from './OneRoomNoticePopup'

function mapStateToProps(state: any) {
  const selectedBeforeImageData = selectBeforeImageData(state)
  return { ...state.roomDesign, selectedBeforeImageData }
}

const SelectRoomType = (props: any) => {
  const {
    isRoomTypePopupShow,
    selectedBeforeImageData,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const [isOneRoomNoticeOpen, setIsOneRoomNoticeOpen] = useState(false)
  const [ignoreNoticeFlag, setIgnoreNoticeFlag] = useState(false)

  if (!selectedBeforeImageData) return null
  const {roomType} = selectedBeforeImageData
  const closePopup = () => {
    dispatch(roomDesignActions.setIsRoomTypePopupShow(false))
  }
  const setRoomType = (value: any) => {
    dispatch(roomDesignActions.setRoomType(value))
    dispatch(roomDesignActions.setIsRoomTypePopupShow(false))

    // ワンルーム選択時に注意ポップアップを表示（フラグが立っていない場合のみ）
    if (value === "oneRoom") {
      const hidden = localStorage.getItem('oneRoomNoticeHidden')
      if (hidden !== 'true') {
        setIgnoreNoticeFlag(false)
        setIsOneRoomNoticeOpen(true)
      }
    }
  }

  return (
    <>
      <Modal show={isRoomTypePopupShow} onClose={closePopup}>
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
                  <h3 className="text-xl font-semibold text-gray-900">
                    部屋タイプ
                  </h3>
                  <button type="button" onClick={closePopup}
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center">
                    <CloseModalIcon />
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
                <div className="p-4 md:p-5 space-y-4">

                  <div className="grid gap-3 grid-cols-2">
                    <div className="relative col-1">
                      <label onClick={() => setRoomType("living")}
                        className={roomType == "living"
                          ? "border-1 border-yellow-300 bg-yellow-300 flex cursor-pointer select-none border overflow-hidden h-full group"
                          : "bg-white border-1 border-gray-200 flex cursor-pointer select-none border overflow-hidden h-full group"
                        }>
                        <span className="bg-[#ff4600cc] absolute top-1/2 -mt-6 inset-x-0 p-2 text-center font-bold text-[#2d2d2d] text-white">リビング</span>
                        <figure>
                          <img src={pho_living} alt="リビング" className="w-full h-auto object-cover"/>
                        </figure>
                      </label>
                    </div>

                    <div className="relative col-1">
                      <label onClick={() => setRoomType("dining")}
                        className={roomType == "dining"
                          ? "border-1 border-yellow-300 bg-yellow-300 flex cursor-pointer select-none border overflow-hidden h-full group"
                          : "bg-white border-1 border-gray-200 flex cursor-pointer select-none border overflow-hidden h-full group"
                        }>
                        <span className="bg-[#ff4600cc] absolute top-1/2 -mt-6 inset-x-0 p-2 text-center font-bold text-[#2d2d2d] text-white">ダイニング</span>
                        <figure>
                          <img src={pho_dining} alt="ダイニング" className="w-full h-auto object-cover"/>
                        </figure>
                      </label>
                    </div>

                    <div className="relative col-1">
                      <label onClick={() => setRoomType("bedroom")}
                        className={roomType == "bedroom"
                          ? "border-1 border-yellow-300 bg-yellow-300 flex cursor-pointer select-none border overflow-hidden h-full group"
                          : "bg-white border-1 border-gray-200 flex cursor-pointer select-none border overflow-hidden h-full group"
                        }>
                        <span className="bg-[#ff4600cc] absolute top-1/2 -mt-6 inset-x-0 p-2 text-center font-bold text-[#2d2d2d] text-white">ベッドルーム</span>
                        <figure>
                          <img src={pho_bedroom} alt="ベッドルーム" className="w-full h-auto object-cover"/>
                        </figure>
                      </label>
                    </div>

                    <div className="relative col-1">
                      <label onClick={() => setRoomType("oneRoom")}
                        className={roomType == "oneRoom"
                          ? "border-1 border-yellow-300 bg-yellow-300 flex cursor-pointer select-none border overflow-hidden h-full group"
                          : "bg-white border-1 border-gray-200 flex cursor-pointer select-none border overflow-hidden h-full group"
                        }>
                        <span className="bg-[#ff4600cc] absolute top-1/2 -mt-6 inset-x-0 p-2 text-center font-bold text-[#2d2d2d] text-white">ワンルーム</span>
                        <figure>
                          <img src={pho_oneroom} alt="ワンルーム" className="w-full h-auto object-cover"/>
                        </figure>
                      </label>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setIgnoreNoticeFlag(true);
                          setIsOneRoomNoticeOpen(true);
                        }}
                        className="absolute top-1 right-1 bg-white rounded-full shadow-md hover:bg-gray-100 z-10"
                        style={{ padding: '2px' }}
                        title="ワンルームの注意点を確認"
                      >
                        <InfoIcon className="w-5 h-5 text-orange-500" />
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* ワンルーム注意点ポップアップ */}
      <OneRoomNoticePopup
        isOpen={isOneRoomNoticeOpen}
        onClose={() => setIsOneRoomNoticeOpen(false)}
        ignoreFlag={ignoreNoticeFlag}
      />
    </>
  );
};

export default connect(mapStateToProps)(SelectRoomType)
